import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable, Subject} from 'rxjs';

import {handleMultiScan} from 'shared/utils';
import {ContentState} from 'shared/types';
import {ListState, StreamInput} from 'shared/interfaces';
import {ContentStatus} from 'shared/enums';
import {TournamentModel} from 'shared/models';

@Injectable()
export class TournamentsService {
  readonly listSubject: BehaviorSubject<StreamInput<ListState<TournamentModel>>>;
  readonly add: Subject<TournamentModel>;
  readonly update: Subject<{
    model: TournamentModel;
    oldModel: TournamentModel;
  }>;
  readonly remove: Subject<TournamentModel>;

  readonly listState$: Observable<ContentState<ListState<TournamentModel>>>;
  // readonly status$!: Observable<ContentStatus>;
  // readonly error$!: Observable<HttpErrorResponse | Error | undefined>;
  // readonly value$!: Observable<ListState<TournamentModel> | undefined>;

  constructor() {
    this.listSubject = new BehaviorSubject<StreamInput<ListState<TournamentModel>>>(
      {
        status: ContentStatus.INITIATED,
      }
    );
    this.add = new Subject<TournamentModel>();
    this.update = new Subject<{
      model: TournamentModel;
      oldModel: TournamentModel;
    }>();
    this.remove = new Subject<TournamentModel>();

    this.listState$ = this.listSubject.pipe(
    // const listState$ = this.listSubject.pipe(
      handleMultiScan<ListState<TournamentModel>, TournamentModel>({
        add: this.add,
        update: this.update,
        remove: this.remove,
      })
    );

    // this.status$ = listState$.pipe(
    //   map((state: ContentState<ListState<TournamentModel>>): ContentStatus => {
    //     return state.status;
    //   })
    // );
    // this.error$ = listState$.pipe(
    //   map((state: ContentState<ListState<TournamentModel>>): HttpErrorResponse | Error | undefined => {
    //     return state.error;
    //   })
    // );
    // this.value$ = listState$.pipe(
    //   map((state: ContentState<ListState<TournamentModel>>): ListState<TournamentModel> | undefined => {
    //     return state.value;
    //   })
    // );
  }
}
